module.exports = __webpack_public_path__ + "static/img/taskView.adb0a4e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/imageSaver/taskView.svg
// module id = S8Dk
// module chunks = 1